import dayjs from 'dayjs'
const ym=(date)=> dayjs(date).isValid() ? dayjs(date).format("YYYY-MM") : '---';
const m =(date)=> dayjs(date).isValid() ? dayjs(date).format("MM") : '---';
const y =(date)=> dayjs(date).isValid() ? dayjs(date).format("YYYY") : '---';

//.subtract(1, 'month')
const ym_1=(date)=> dayjs(date).isValid() ? dayjs(date).subtract(1, 'month').format("YYYY-MM") : '---';
const ym_2=(date)=> dayjs(date).isValid() ? dayjs(date).subtract(2, 'month').format("YYYY-MM") : '---';

export {m, y, ym, ym_1, ym_2}
